// @ts-ignore
import {IOrderTrueDriverTravelObjectivesState} from "./states/IOrderTrueDriverTravelObjectivesState.interface";

const orderTrueDriverTravelObjectives = {
    namespaced: true,
    state: <IOrderTrueDriverTravelObjectivesState>{
        travelObjectives: null
    },

    mutations: {
        SET_TRAVEL_OBJECTIVES(state, payload) {
            state.travelObjectives = [...payload];
        }
    },

    actions: {
        initializeTravelObjectives(context, payload: []): void {
            context.commit('SET_TRAVEL_OBJECTIVES', payload);
        }
    }



}

export default orderTrueDriverTravelObjectives;